import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AreaFocus } from '../../../models';
import { Router } from '@angular/router';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
var PersonalComponent = /** @class */ (function () {
    function PersonalComponent(_services, _parent, router, googleAnalyticsEventsService) {
        this._services = _services;
        this._parent = _parent;
        this.router = router;
        this.googleAnalyticsEventsService = googleAnalyticsEventsService;
        //states: any[] = stateConstant;
        this.formClass = "";
        this.errormsg = new Array();
        this.errdisplay = false;
        this.trackingName = "Personal";
        this.loading = false;
    }
    PersonalComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, elmnt;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._parent.campaignName) {
                            this.trackingName = this._parent.campaignName + " - Personal";
                        }
                        //this.majors = await this._services.getList('/majorslevel');
                        _a = this;
                        return [4 /*yield*/, this._services.getList('/primary/bucketlist')];
                    case 1:
                        //this.majors = await this._services.getList('/majorslevel');
                        _a.bucketlist = _b.sent();
                        this.loading = true;
                        elmnt = document.getElementById("top");
                        elmnt.scrollIntoView();
                        return [2 /*return*/];
                }
            });
        });
    };
    PersonalComponent.prototype.clickSubmit = function (valid) {
        this.errormsg = [];
        if (this._parent.model.primary_bucket.length < 1) {
            $(".pbucket").addClass('errorclass');
            valid = false;
        }
        if (valid) {
            this.personalsubmit();
        }
        else {
            if (this._parent.model.primary_bucket.length < 1) {
                this.errdisplay = true;
                this.errormsg.push("Please select area of study.");
            }
            this.formClass = "validate";
        }
    };
    PersonalComponent.prototype.personalsubmit = function () {
        this._parent.model.bucket_text = this._parent.model.primary_bucket.map(function (a) { return a.name; }).join(',');
        this._parent.model.bucket_id = this._parent.model.primary_bucket.map(function (a) { return a.id; }).join(',');
        //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 2);
        this._parent.index++;
    };
    PersonalComponent.prototype.prevAction = function () {
        this._parent.index--;
        //this.router.navigate(['/']);
    };
    PersonalComponent.prototype.primarySelected = function (id, title) {
        this._parent.model.secondary_bucket = [];
        this._parent.model.secondary_bucket_ids = "";
        if (this._parent.model.primary_bucket.length > 0) {
            var primaryCount = this._parent.model.primary_bucket.length;
            var index = this._parent.model.primary_bucket.findIndex(function (x) { return x.id == id; });
            if (index > -1) {
                this._parent.model.primary_bucket.splice(index, 1);
            }
            else {
                if (primaryCount < 3) {
                    var csitem = new AreaFocus();
                    csitem.name = title;
                    csitem.id = id;
                    this._parent.model.primary_bucket.push(csitem);
                }
                else {
                    alert("You cannot select more than 3 Area Of Study");
                }
            }
        }
        else {
            $(".pbucket").removeClass('errorclass');
            var csitem = new AreaFocus();
            csitem.name = title;
            csitem.id = id;
            this._parent.model.primary_bucket.push(csitem);
        }
    };
    PersonalComponent.prototype.getSelectedBucket = function (id) {
        if (this._parent.model.primary_bucket.length > 0) {
            var index = this._parent.model.primary_bucket.findIndex(function (x) { return x.id == id; });
            if (index > -1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    return PersonalComponent;
}());
export { PersonalComponent };



// WEBPACK FOOTER //
// ./src/app/components/pworkflow/personal/personal.component.ts.pre-build-optimizer.js